var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellsmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35 4.4c0 .63.17 1 .53 1.42.28.32.37.72.37 1.16 0 .44-.14.85-.43 1.19-.38.4-.9.66-1.45.7a20.82 20.82 0 0 1-4.74 0 2.27 2.27 0 0 1-1.45-.7 1.8 1.8 0 0 1-.43-1.2c0-.43.09-.83.37-1.15.37-.42.53-.8.53-1.42v-.21c0-.85.2-1.4.64-1.93A3.54 3.54 0 0 1 5.98 1h.04c1.04 0 2.1.5 2.74 1.31.4.53.6 1.06.6 1.88v.2Zm-4.81 5.63c0-.25.23-.37.44-.42.25-.05 1.77-.05 2.02 0 .22.05.45.17.45.42a.78.78 0 0 1-.35.59 1.82 1.82 0 0 1-1.36.36 1.8 1.8 0 0 1-.86-.36.78.78 0 0 1-.34-.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellsmall);
export default __webpack_public_path__ + "static/media/bell.small.2912992d372d956ecb2ed4e2fa7c1b01.svg";
export { ForwardRef as ReactComponent };